module.exports = "../fonts/hotel_childrens_icon.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hotel_childrens_icon.svg
// module id = 436
// module chunks = 0